import React from 'react'

const TABLE_BORDER = '#6b6b6b';
const HEADER_BG = '#f7f7f7';
const LABEL_COLOR = '#2f2f2f';
const VALUE_COLOR = '#4a4a4a';
const TABLE_FONT_SIZE = 11;
const FIRST_COLUMN_WIDTH = 108;
const VALUE_COLUMN_WIDTH = 76;
const CELL_PADDING = '4px 6px';

const InsightPyramidTableView = ({ rows }) => {
    if (!Array.isArray(rows) || rows.length === 0) {
        return null;
    }

    const valueHeaders = rows[0].values.map((item) => item.label);

    return (
        <div style={{
            minWidth: 280,
            border: `1px solid ${TABLE_BORDER}`,
            background: '#fff',
            fontSize: TABLE_FONT_SIZE,
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: `${FIRST_COLUMN_WIDTH}px repeat(${valueHeaders.length}, ${VALUE_COLUMN_WIDTH}px)`,
                borderBottom: `1px solid ${TABLE_BORDER}`,
                background: HEADER_BG,
                fontWeight: 700,
                color: LABEL_COLOR,
                lineHeight: 1.2,
            }}>
                <div style={{ padding: CELL_PADDING, borderRight: `1px solid ${TABLE_BORDER}` }}>Margin Group</div>
                {valueHeaders.map((header, index) => (
                    <div key={header} style={{
                        padding: CELL_PADDING,
                        borderRight: index < valueHeaders.length - 1 ? `1px solid ${TABLE_BORDER}` : 'none',
                        textAlign: 'right',
                        whiteSpace: 'normal',
                    }}>
                        {header}
                    </div>
                ))}
            </div>
            {rows.map((row, rowIndex) => (
                <div key={`${row.label}-${rowIndex}`} style={{
                    display: 'grid',
                    gridTemplateColumns: `${FIRST_COLUMN_WIDTH}px repeat(${row.values.length}, ${VALUE_COLUMN_WIDTH}px)`,
                    borderBottom: rowIndex < rows.length - 1 ? `1px solid ${TABLE_BORDER}` : 'none',
                    lineHeight: 1.15,
                }}>
                    <div style={{
                        padding: CELL_PADDING,
                        borderRight: `1px solid ${TABLE_BORDER}`,
                        color: LABEL_COLOR,
                        fontWeight: 700,
                    }}>
                        {row.label}
                    </div>
                    {row.values.map((item, valueIndex) => (
                        <div key={`${row.label}-${item.label}`} style={{
                            padding: CELL_PADDING,
                            borderRight: valueIndex < row.values.length - 1 ? `1px solid ${TABLE_BORDER}` : 'none',
                            textAlign: 'right',
                            color: item.textColor || VALUE_COLOR,
                            background: item.backgroundColor || 'transparent',
                        }}>
                            {item.displayValue || item.value}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default InsightPyramidTableView